module.exports = "<select class=\"language-switch\" ng-model=\"$ctrl.cur_lang\"  ng-change=\"$ctrl.switching($ctrl.cur_lang)\">\n    <option value=\"en\">English</option>\n    <option value=\"zh-CN\">简体中文</option>\n    <option value=\"japanese\">Japanese</option>\n</select>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/language/language.html
// module id = 721
// module chunks = 3